export default {
    name: 'modal-confirmation',
    components: {},
    props: ["montant", "idOp"],
    data() {
        return {
            confirm_versement: false,
            error_selection: false,
            save_loading: false
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        submitConfirmation() {
            this.save_loading = true;
            if (!this.confirm_versement) {
                this.error_selection = true;
                this.save_loading = false;
                return;
            }
            this.error_selection = false;
            this.$store.dispatch('confirmVersementReception', this.idOp).then(
                (response) => {
                    console.log(response)
                    this.save_loading = false;
                    this.confirm_versement = false;
                    this.doSuccessMsg('Confirmation effectuée')
                    this.$emit('updateConfirmStatus')
                    this.$refs.close_modal.click()
                }
            )
        },
        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            let to_print = "Veuillez choisir tous les éléments nécessaires pour l'enregistrement";
            if (msg)
                to_print = msg

            if (this.$toasted != null) this.$toasted.clear()

            this.$toasted.show(to_print, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
    }
}